/**
 * Shared form-control styling — the chalk-tinted, rounded field first used on
 * the Login screen, lifted here so every admin form (Settings, the menu
 * editors, etc.) matches it instead of the three ad-hoc input styles that had
 * drifted apart. Compose with `cn()` to vary width or font per field, e.g.
 * `cn(fieldClass, 'w-24 font-mono')` — tailwind-merge resolves the conflict so
 * the later width/font wins.
 */
export const fieldClass =
  'w-full rounded-xl border border-wca-gray-light bg-wca-chalk/40 px-3.5 py-2.5 text-sm transition-colors focus:border-wca-red focus:bg-wca-surface focus:outline-none focus:ring-2 focus:ring-wca-red/25 disabled:cursor-not-allowed disabled:opacity-60';
